<app-retailer-list [url]="API.LIST_RETAILER_PENDING_SUBMISSION" [tableColumns]="tableColumns" [dataList]="dataList" (totalCount)="onTotalCount($event)"></app-retailer-list>
